const HERO_KEYWORDS = ['怎么样', '靠谱吗', '安全吗', '是不是假的', '有病毒吗'];

export default function Hero() {
  const handleJump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="relative pt-28 pb-16 md:pt-36 md:pb-24 bg-background-100 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.5] pointer-events-none"
        style={{
          background:
            'radial-gradient(60% 50% at 15% 10%, oklch(var(--primary-100)) 0%, transparent 60%), radial-gradient(50% 50% at 90% 20%, oklch(var(--accent-100)) 0%, transparent 60%)',
        }}
      ></div>

      <div className="relative w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 border border-background-300 text-xs text-foreground-700 mb-5">
            <i className="ri-radar-line text-primary-500"></i>
            使用前避坑指南 · 内容观察与风险梳理
          </span>

          <h1 className="font-heading font-black text-foreground-950 text-3xl md:text-5xl leading-tight tracking-tight">
            神马影院怎么样？
            <br />
            靠谱、安全，还是另有隐情
          </h1>

          <p className="mt-5 text-foreground-700 leading-relaxed text-base md:text-lg">
            围绕“神马影院怎么样、靠谱吗、安全吗、是不是假的、有病毒吗”这些最常被问到的疑问，本页汇总了用户反馈与常见风险点，从
            <strong className="text-foreground-900 font-semibold">可靠性、安全性、真伪辨别、口碑评价</strong>
            四个方面做一次尽量客观的梳理，帮你在使用前做出判断，尽量少踩坑。
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {HERO_KEYWORDS.map((k) => (
              <span
                key={k}
                className="px-3 py-1 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-600"
              >
                {k}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={() => handleJump('verdict')}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-compass-3-line"></i>
              直接看核心结论
            </button>
            <button
              type="button"
              onClick={() => handleJump('about')}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 hover:border-primary-300 text-foreground-800 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i>
              从头了解它是什么
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}